import axionIns from "../axios";

const getPayouts = async (page, limit, status) => {
  return axionIns
    .get(`admin/listpayoutrequests?page=${page}&limit=${limit ? limit : 25}&status=${status}`)
    .then((response) => {
      return response.data;
    });
};

const payProvider = async (id, amount) => {
  return axionIns
    .post("admin/paybypayoutreqid/" + id, JSON.stringify({amount: amount}))
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error?.response?.data ? error?.response?.data : { status: false };
    });
};

const getPayout = async (id) => {
  return axionIns
    .get(`admin/payout/${id}`)
    .then((response) => {
      return response.data;
    });
};

export default {
  getPayouts,
  payProvider,
  getPayout
};
